module.exports = __webpack_public_path__ + "img/error-form.0a92c4dd.svg";